import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import { Email_Validation, ERROR_MSG, MOBILE_VALIDATION } from "./CommonUtils/contextVariables";
import * as bie from "react-bootstrap";
import { config } from "./CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "./CommonUtils/CommonAxios";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "./CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import { failureAlert } from "./CommonUtils/SweetAlerts";
import Commonheader from "./CommonUtils/Commonheader";
import FacultyHeader from "./FacultyHeader";

export default function UniversityFacultyData() {
    // **********validations********
    const validationSchema = Yup.object({
        facName: Yup.string().required(ERROR_MSG),
        gender: Yup.string().required(ERROR_MSG),
        dob: Yup.string().required(ERROR_MSG),
        doj: Yup.string().required(ERROR_MSG),
        cfmsId: Yup.string().required(ERROR_MSG),
        deptSubject: Yup.string().required(ERROR_MSG),
        facType: Yup.string().required(ERROR_MSG),
        category: Yup.string().required(ERROR_MSG),
        caste: Yup.string().required(ERROR_MSG),
        subCaste: Yup.string().required(ERROR_MSG),
        isPh: Yup.string().required(ERROR_MSG),
        typeOfDisability: Yup.string().required(ERROR_MSG),
        perDisability: Yup.string().required(ERROR_MSG),
        exServiceman: Yup.string().required(ERROR_MSG),
        sportsQuota: Yup.string().required(ERROR_MSG),
        appointCat: Yup.string().required(ERROR_MSG),
        localDist: Yup.string().required(ERROR_MSG),
        qualificationAppoint: Yup.string().required(ERROR_MSG),
        qualificationLater: Yup.string().required(ERROR_MSG),

        contact: Yup.string()
            .required(ERROR_MSG).nullable()
            .matches(MOBILE_VALIDATION, "Invalid mobile number"),
        emailId: Yup.string().required(ERROR_MSG).nullable().matches(Email_Validation, "Invalid Email Address"),
    });
    // *********** formik********
    const facultyDetailsFormik = useFormik({
        initialValues: {
            facName: "",
            gender: "",
            dob: "",
            doj: "",
            cfmsId: "",
            deptSubject: "",
            facType: "",
            category: "",
            caste: "",
            subCaste: "",
            isPh: "",
            typeOfDisability: "",
            perDisability: "",
            exServiceman: "",
            sportsQuota: "",
            appointCat: "",
            localDist: "",
            qualificationAppoint: "",
            qualificationLater: "",
            contact: "",
            emailId: "",
        },
        validationSchema,
        onSubmit: (val) => {
            console.log("Submitted values:", val);

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveFacData`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {

                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    });

    // *******faculty type --get api*******
    const [facultyType, setFacultyType] = useState([]);
    function GetFacultyDetails() {
        let url = `${config.url.FAC_URL}getFacType`;
        console.log("url>>>>", url);
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setFacultyType(res.data.type || []);
            } else {
                setFacultyType([]);
            }
        });
    }



    const [category, setCategory] = useState([]);
    function GetCategoryList() {
        let url = `${config.url.FAC_URL}getCategoryList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setCategory(res.data.category || []);
            } else {
                setCategory([]);
            }
        });
    }



    const [appointedCategory, setAppointedCategory] = useState([]);
    function GetAppointedCategory() {
        let url = `${config.url.FAC_URL}getAppointedCatList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setAppointedCategory(res.data.AppointedCategory || []);
            } else {
                setAppointedCategory([]);
            }
        });
    }
    const [subCasteList, setSubCasteList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    function GetCaste() {
        let url = `${config.url.FAC_URL}geSubCasteList`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {

                const cleanedData = (res.data.subCaste || []).map(item => ({
                    ...item,
                    sub_caste_name: item.sub_caste_name?.trim()
                }));

                setSubCasteList(cleanedData);

                const uniqueCastes = [
                    ...new Set(cleanedData.map(item => item.caste_code))
                ];

                setCasteList(uniqueCastes);
            }
        });
    }



    const [distlist, setDistlist] = useState([]);

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDistricts`
        );
        setDistlist(res?.data?.scode === "01" ? res.data.getDistricts : []);
    };



    useEffect(() => {
        GetFacultyDetails();
        GetCaste();
        GetCategoryList();
        GetAppointedCategory();
        fetchDistList();
    }, []);
    const filteredSubCaste = subCasteList.filter(
        item => item.caste_code === facultyDetailsFormik.values.caste
    );


    return (
        <>

            <FacultyHeader />
            <div className="faculty-form-wrapper">
                <div className="faculty-card">

                    <h4 className="form-title">
                        University   Faculty Data
                    </h4>

                    <FormikProvider value={facultyDetailsFormik}>
                        <Form className="form_adjust">
                            <bie.Row>
                                {/* Faculty Name */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Faculty Name</label>
                                    <Field name="facName" className="form-control" maxLength={60} onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage
                                        name="facName"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Gender */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Gender</label>
                                    <Field as="select" name="gender" className="form-control">
                                        <option value="">Select</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </Field>
                                    <ErrorMessage
                                        name="gender"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Date of Birth */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Date of Birth</label>
                                    <Field type="date" name="dob" className="form-control" max="2000-12-31"
                                    />
                                    <ErrorMessage name="dob" component="div" className="text-danger" />
                                </bie.Col>

                                {/* Date of Joining */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Date of Joining in the university </label>
                                    <Field type="date" name="doj" className="form-control" />
                                    <ErrorMessage
                                        name="doj"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* CFMS ID */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>CFMS ID</label>
                                    <Field name="cfmsId" className="form-control" onKeyPress={allowNumbersOnly} maxLength={8} />
                                    <ErrorMessage
                                        name="cfmsId"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Department */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Department / Subject</label>
                                    <Field name="deptSubject" className="form-control" maxLength={50} onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage
                                        name="deptSubject"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Faculty Type */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Type of Faculty</label>
                                    <Field as="select" name="facType" className="form-control">
                                        <option value="">--Select--</option>
                                        {facultyType?.map((p) => (
                                            <option key={p.fac_type_id} value={p.fac_type_id}>
                                                {p.fac_type_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="facType" component="div" className="text-danger" />

                                </bie.Col>

                                {/* Category */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Category</label>
                                    <Field as="select" name="category" className="form-control">
                                        <option value="">--Select--</option>
                                        {category?.map((p) => (
                                            <option key={p.cat_id} value={p.cat_id}>
                                                {p.cat_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage
                                        name="category"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Caste */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Caste</label>

                                    <select
                                        name="caste"
                                        className="form-control"
                                        value={facultyDetailsFormik.values.caste}
                                        onChange={(e) => {
                                            facultyDetailsFormik.handleChange(e);
                                            facultyDetailsFormik.setFieldValue("subCaste", ""); // reset sub caste
                                        }}
                                    >
                                        <option value="">Select Caste</option>

                                        {casteList?.map((casteCode, index) => (
                                            <option key={index} value={casteCode}>
                                                {casteCode}
                                            </option>
                                        ))}
                                    </select>


                                    <ErrorMessage
                                        name="caste"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Sub Caste */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Sub Caste</label>
                                    <select
                                        name="subCaste"
                                        className="form-control"
                                        value={facultyDetailsFormik.values.subCaste}
                                        onChange={facultyDetailsFormik.handleChange}
                                    >
                                        <option value="">Select Sub Caste</option>

                                        {filteredSubCaste.map((item) => (
                                            <option
                                                key={item.sub_caste_code}
                                                value={item.sub_caste_code}
                                            >
                                                {item.sub_caste_name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage
                                        name="subCaste"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Physically Challenged */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Physically Challenged</label>
                                    <Field
                                        as="select"
                                        name="isPh"
                                        className="form-control"
                                    >
                                        <option value="">Select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </Field>
                                    <ErrorMessage
                                        name="isPh"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Disability Fields */}
                                {facultyDetailsFormik.values.isPh === "true" && (
                                    <>
                                        <bie.Col
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={4}
                                            xxl={4}
                                            className="mb-2"
                                        >
                                            <label>Type of Disability</label>
                                            <Field name="typeOfDisability" className="form-control" />
                                            <ErrorMessage
                                                name="typeOfDisability"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </bie.Col>

                                        <bie.Col
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={4}
                                            xxl={4}
                                            className="mb-2"
                                        >
                                            <label>Percentage of Disability</label>
                                            <Field name="perDisability" className="form-control" onKeyPress={allowNumbersOnly} maxLength={2} />
                                            <ErrorMessage
                                                name="perDisability"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </bie.Col>
                                    </>
                                )}

                                {/* Ex Servicemen */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Ex Servicemen</label>
                                    <Field as="select" name="exServiceman" className="form-control">
                                        <option value="">Select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </Field>
                                    <ErrorMessage
                                        name="exServiceman"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Sports Quota */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Sports Quota</label>
                                    <Field as="select" name="sportsQuota" className="form-control">
                                        <option value="">Select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </Field>
                                    <ErrorMessage
                                        name="sportsQuota"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Appointed Category */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Appointed Category</label>


                                    <select
                                        name="appointCat"
                                        className="form-control"
                                        value={facultyDetailsFormik.values.appointCat}
                                        onChange={(e) => {
                                            facultyDetailsFormik.handleChange(e);
                                        }}
                                    >
                                        <option value="">--Select Appointed Category--</option>

                                        {appointedCategory?.map((app, index) => (
                                            <option key={index} value={app?.appoint_cat_id}>
                                                {app?.appoint_cat_name}
                                            </option>
                                        ))}
                                    </select>

                                    <ErrorMessage
                                        name="appointCat"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Local District */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Local District</label>
                                    {/* <Field name="localDist" className="form-control" /> */}
                                    <Field
                                        as="select"
                                        name="localDist"
                                        className="form-control form-control-md"

                                    >
                                        <option value="">---select---</option>
                                        {distlist?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage
                                        name="localDist"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Qualification at Joining */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Qualifications at the time of appointment</label>
                                    <Field name="qualificationAppoint" className="form-control" maxLength={100} onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage
                                        name="qualificationAppoint"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Qualification Later */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Qualification Acquired Later</label>
                                    <Field name="qualificationLater" className="form-control" maxLength={100} onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage
                                        name="qualificationLater"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* WhatsApp */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Whatsapp Number</label>
                                    <Field name="contact" className="form-control" onKeyPress={allowNumbersOnly} maxLength={10} />
                                    <ErrorMessage
                                        name="contact"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>

                                {/* Email */}
                                <bie.Col
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={6}
                                    xl={4}
                                    xxl={4}
                                    className="mb-2"
                                >
                                    <label>Email ID</label>
                                    <Field name="emailId" className="form-control" />
                                    <ErrorMessage
                                        name="emailId"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>
                                <div className="text-end mt-3">
                                    <button type="submit" className="submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </bie.Row>
                        </Form>
                    </FormikProvider>
                </div>
            </div>
        </>
    );
}